import { render, staticRenderFns } from "./PhuongThucThanhToan.vue?vue&type=template&id=32bddbf2&scoped=true&"
import script from "./PhuongThucThanhToan.vue?vue&type=script&lang=js&"
export * from "./PhuongThucThanhToan.vue?vue&type=script&lang=js&"
import style0 from "./PhuongThucThanhToan.vue?vue&type=style&index=0&id=32bddbf2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bddbf2",
  null
  
)

export default component.exports